import { ContractName } from '@/constants/contract-addresses'
import useReadContract from './useReadContract'
import { blockpotRewardTrackerAbi } from '@/abi/blockPotRewardTrackerAbi'

export default function useBlockPotRewardTrackerRead() {
    return useReadContract(ContractName.BLOCK_POT_REWARD_TRACKER, blockpotRewardTrackerAbi).read
}